import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ParametrosService } from './parametros.service';
import { ServerUrlService } from './server-url.service';
import { Session } from 'protractor';
import { Observable } from 'rxjs';

interface Response extends Array<any> {}

@Injectable({
  providedIn: 'root'
})
export class HorariosService {

  constructor(
    private http: HttpClient,
    private parametros: ParametrosService,
    private serverUrlService: ServerUrlService
  ) { }

  otimusUrl?: string

  consultaHorarios(agendas: any, selecaoObj: any, exames: any, suceder: any, procedimento: any) {
    const { convenio, plano, especialidade, dataInicial, requestingPhysicianId } = selecaoObj;
    const ano = dataInicial.getFullYear();
    const mes = dataInicial.getMonth();
    const dia = dataInicial.getDate();
    let mesStr = mes + 1;
    if (mesStr < 10) { mesStr = `0${mesStr}`; }
    const dataStr = `${ano}-${mesStr}-${dia}`;

    const query = {
      agendas,
      convenio,
      plano,
      especialidade,
      data: dataStr,
      exames,
      startTime: suceder,
      requestingPhysicianId,
      procedimento: procedimento
    };

    const options = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    };

    return this.http.post(
      `${this.serverUrlService.getUrl()}/horarios`, query, options
    );
  }

  trancaHorario(horario: any) {
    return this.http.post<Response>(
      `${this.serverUrlService.getUrl()}/horarios/tranca`, horario
    );
  }

  confirmaAgendamento(sessionData: any, returnData?: boolean): Observable<any> {
    const { userData, selecaoObj, horarioSel, infoPagamento } = sessionData;
    const nascimento = new Date(userData.nascimento).toISOString().slice(0, 10);

    let usuarioOtimus: string;

    const valorPacienteDefault = this.parametros.getParams('APP_PATIENT_DEFAULT');
    usuarioOtimus = valorPacienteDefault.valor;
    let status = 'pendente';
    if (userData.integracao_id) {
      usuarioOtimus = userData.integracao_id.toString();
      status = 'agendado';
    }

    const agendas = JSON.parse(sessionStorage.getItem('agendas')) || [];
    const agendaSelecionada = agendas.find((fnd) =>
    fnd.integracao_id.toString() === horarioSel.hora.agendaid.toString()
    && fnd.tipo_agenda.toString() === horarioSel.hora.tipo.replace('ag', 'consulta').replace('cs', 'exames').toString()
    );
    const procedimentoParam = agendaSelecionada.procedimentos.find((fnd) => fnd.integracao_id.toString() === selecaoObj.procedimento.procedimento_integracao_id.toString());

    const query = {
      usuario_id: userData.id,
      usuario_int_id: usuarioOtimus,
      nome: userData.nome,
      fone: userData.fone,
      nascimento,
      convenio_id: selecaoObj.convenio.id,
      convenio_int_id: selecaoObj.convenio.integracao_id,
      convenio_nome: selecaoObj.convenio.descricao,
      plano_id: selecaoObj.plano.id,
      plano_int_id: selecaoObj.plano.integracao_id,
      plano_nome: selecaoObj.plano.descricao,
      carteirinha: selecaoObj.convenio.carteirinha,
      data: horarioSel.data,
      hora: horarioSel.hora.hora,
      agenda_id: agendaSelecionada.id,
      agenda_int_id: agendaSelecionada.integracao_id,
      agenda_tipo: agendaSelecionada.tipo_agenda === 'exames' ? 'cs' : 'ag',
      agenda_nome: horarioSel.agenda,
      especialidade_id: selecaoObj.especialidade.id,
      especialidade_nome: selecaoObj.especialidade.descricao,
      validade_carteirinha: selecaoObj.validadeCarteirinha,
      pagamento_asaas_id: infoPagamento.id,
      bandeira_assas: infoPagamento.creditCardBrand,
      pagamento_valor: infoPagamento.value,
      servicos: [procedimentoParam], // JSON.parse(sessionStorage.getItem('procedimentos')),
      status,
      requestingPhysicianId: selecaoObj.requestingPhysicianId,
      tipo_pagamento: infoPagamento.paidWithPix ? 'pix' : 'cartao_credito',
    };


    if(returnData) return query as any

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      token: userData.token
    });

    const options = {
      headers,
      observer: 'response' as 'body'
    };
    const url = `${this.serverUrlService.getUrl()}/horarios/confirma`;

    return this.http.post<Response>(url, query, options);
  }

  getOtimusURL() {
    return this.http.post(`https://cms-backend.otimusclinic.com/variables/host/${this.serverUrlService.name}`, {})
  }

  getRules() {
    return this.http.get(`${this.otimusUrl}/cadastros/regras/crud`)
  }

  getRule(body: any) {
    return this.http.post(`${this.otimusUrl}/cadastros/regras/check`, body)
  }
}
